(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractDocumentsController', ContractDocumentsController);

    ContractDocumentsController.$inject = ['$stateParams', '$window', '$translate', 'entity', 'ContractDocuments', 'AlertService', 'Principal'];

    function ContractDocumentsController($stateParams, $window, $translate, entity, ContractDocuments, AlertService, Principal) {
        var vm = this;

        vm.contrat = entity;
        vm.idContrat = $stateParams.id;
        vm.documents = [];
        vm.canEdit = false;
        vm.selectedDocumentFile = null;
        vm.selectedDocumentFileName = null;
        vm.uploadInProgress = false;
        vm.maxDocumentSizeMb = 50;
        vm.maxDocumentSizeBytes = 50 * 1024 * 1024;

        vm.load = load;
        vm.setDocumentFile = setDocumentFile;
        vm.uploadDocument = uploadDocument;
        vm.downloadDocument = downloadDocument;
        vm.deleteDocument = deleteDocument;
        vm.isDeleted = isDeleted;
        vm.formatFileSize = formatFileSize;

        Principal.identity().then(function(account) {
            if (!account) {
                return;
            }
            vm.canEdit = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
                || account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
                || account.authorities.indexOf('ROLE_ADMIN') !== -1;
        });

        load();

        function load() {
            ContractDocuments.query(vm.idContrat).then(function(result) {
                vm.documents = result;
            }, handleError);
        }

        function setDocumentFile(file) {
            vm.selectedDocumentFile = file || null;
            vm.selectedDocumentFileName = file && file.name ? file.name : null;
            if (file && file.size > vm.maxDocumentSizeBytes) {
                AlertService.error($translate.instant('wamasysApp.contrat.documents.maxSizeError', { size: vm.maxDocumentSizeMb }));
                clearFileSelection();
            }
        }

        function uploadDocument() {
            if (!vm.canEdit || !vm.selectedDocumentFile) {
                return;
            }
            vm.uploadInProgress = true;
            ContractDocuments.upload(vm.idContrat, vm.selectedDocumentFile).then(function() {
                vm.uploadInProgress = false;
                clearFileSelection();
                AlertService.success($translate.instant('wamasysApp.contrat.documents.addedSuccess'));
                load();
            }, function(error) {
                vm.uploadInProgress = false;
                handleError(error);
            });
        }

        function downloadDocument(contractDocument) {
            if (!contractDocument || !contractDocument.id || isDeleted(contractDocument)) {
                return;
            }
            ContractDocuments.download(vm.idContrat, contractDocument.id).then(function(result) {
                if ($window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(result.response, result.fileName);
                    return;
                }
                var url = ($window.URL || $window.webkitURL).createObjectURL(result.response);
                var link = angular.element('<a/>');
                link.attr('href', url);
                link.attr('download', result.fileName);
                angular.element(document.body).append(link);
                link[0].click();
                link.remove();
                ($window.URL || $window.webkitURL).revokeObjectURL(url);
            }, handleError);
        }

        function deleteDocument(contractDocument) {
            if (!vm.canEdit || !contractDocument || !contractDocument.id || isDeleted(contractDocument)) {
                return;
            }
            if (!$window.confirm($translate.instant('wamasysApp.contrat.documents.deleteConfirm'))) {
                return;
            }
            ContractDocuments.deleteDocument(vm.idContrat, contractDocument.id).then(function() {
                AlertService.success($translate.instant('wamasysApp.contrat.documents.deletedSuccess'));
                load();
            }, handleError);
        }

        function isDeleted(contractDocument) {
            return !!(contractDocument && contractDocument.deletedDate);
        }

        function clearFileSelection() {
            vm.selectedDocumentFile = null;
            vm.selectedDocumentFileName = null;
            angular.element('#contractDocumentFileInput').val(null);
        }

        function formatFileSize(sizeBytes) {
            var value = Number(sizeBytes || 0);
            var units = ['B', 'KB', 'MB', 'GB'];
            var unitIndex = 0;
            while (value >= 1024 && unitIndex < units.length - 1) {
                value = value / 1024;
                unitIndex++;
            }
            return (unitIndex === 0 ? Math.round(value) : value.toFixed(2)) + ' ' + units[unitIndex];
        }

        function handleError(error) {
            AlertService.error(resolveErrorMessage(error, $translate.instant('wamasysApp.contrat.documents.technicalError')));
        }

        function resolveErrorMessage(error, defaultMessage) {
            return error && error.data && error.data.message ? error.data.message : defaultMessage;
        }
    }
})();
